import React from 'react';
import styles from './FormError.module.css';

interface FormErrorProps {
  children: React.ReactNode;
}

export const FormError: React.FC<FormErrorProps> = ({ children }) => {
  if (!children) return null;

  return <p className={styles.error}>{children}</p>;
};
